import { object } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getSOCarts } from '@redux/actions/getSOCarts';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { useQuery } from '@utils/customsHook/useQuery';

import Global from '../../../../utils/global';
import BoxData from '../BoxData';
import CustomerSaleOrdersShimmer from './CustomerSaleOrdersShimmer';
import CustomerSaleOrdersModel from './models/CustomerSaleOrdersModel';

const MAX_SO_CART_ITEM = 2;

const CustomerSaleOrders = ({ fields }) => {
  const dispatch = useDispatch();
  const query = useQuery();
  const { soCartStatuses } = useSelector((state) => state.cpSaleOrderStatusesReducer);
  const ordersListing = useSelector((state) => state?.getSOCartsReducer?.dataApi?.Carts || []);
  const isGettingData = useSelector((state) => state?.getSOCartsReducer?.isLoading);
  const [layoutData, setLayoutData] = useState(null);

  useEffect(() => {
    const model = new CustomerSaleOrdersModel();

    setLayoutData(model.getData(fields));
  }, []);

  useEffect(() => {
    const contactId = query.get('contactId');
    if (contactId)
      dispatch(
        getSOCarts({
          ContactId: contactId
        })
      );
  }, [query]);

  return layoutData ? (
    <div className='col-md-6 profiles__col'>
      {!isGettingData ? (
        <BoxData component='last-visit' layoutData={layoutData} linkPage={{ value: { href: '/' } }} data={ordersListing}>
          {ordersListing.map((orderItem) => {
            const convertExpiredDate = Global.convertJSONDateToNumber(orderItem?.ExpiredDate);

            return (
              <div className='box-data__row' key={orderItem?.CartName}>
                <div className='box-data__col-1'>
                  <div className='box-data__title --sub'>
                    {orderItem?.ProductNames?.[0]}{' '}
                    {orderItem?.ProductNames?.length > 1 ? (
                      layoutData?.['Package count']?.value?.replace('{otherCount}', orderItem?.ProductNames?.length - 1) || ''
                    ) : (
                      <></>
                    )}
                  </div>
                  {convertExpiredDate ? (
                    <p className='box-data__notice'>
                      <Text field={layoutData?.['Expire On Text']} /> {Global.customDate(convertExpiredDate)}
                    </p>
                  ) : (
                    <></>
                  )}
                </div>
                <div className='box-data__col-2'>
                  <div className='highlight-text highlight-text--radius'>
                    <span>{soCartStatuses?.[orderItem?.Status || 0]}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </BoxData>
      ) : (
        <CustomerSaleOrdersShimmer title={layoutData?.['Section Title']} />
      )}
    </div>
  ) : (
    <></>
  );
};

CustomerSaleOrders.propTypes = {
  fields: object
};

export default CustomerSaleOrders;
